module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sn-a03bc309423c9052891ad0e5e65dbcee.svg";